// apps/web/src/components/landing-v2/proofs/ClassesProof.tsx
/** Theme 04 / Classes & ceremonies — three scheduled rows.
 *  Reference: handoff .mm-classes. */

type RowPillVariant = 'gold' | 'rose' | 'violet'

const ROWS: {
  month: string
  day: string
  title: string
  meta: string
  pillText: string
  pillVariant: RowPillVariant
}[] = [
  {
    month: 'Nov',
    day: '14',
    title: 'Breath & the cards',
    meta: '60 min · with a guest',
    pillText: 'New',
    pillVariant: 'gold',
  },
  {
    month: 'Nov',
    day: '21',
    title: 'Reading your transits',
    meta: '45 min · live astrology',
    pillText: 'Class',
    pillVariant: 'violet',
  },
  {
    month: 'Nov',
    day: '28',
    title: 'New moon ritual',
    meta: '90 min · ceremony with Sarah',
    pillText: 'Live',
    pillVariant: 'rose',
  },
]

const PILL_STYLES: Record<RowPillVariant, { background: string; color: string; borderColor: string }> = {
  gold: {
    background: 'color-mix(in oklab, var(--color-gold-light-legacy) 12%, transparent)',
    color: 'var(--color-gold-light-legacy)',
    borderColor: 'color-mix(in oklab, var(--color-gold-light-legacy) 28%, transparent)',
  },
  rose: {
    background: 'color-mix(in oklab, var(--color-rose) 14%, transparent)',
    color: 'var(--color-rose-light)',
    borderColor: 'color-mix(in oklab, var(--color-rose) 30%, transparent)',
  },
  violet: {
    background: 'color-mix(in oklab, var(--color-astral-violet) 12%, transparent)',
    color: 'var(--color-astral-violet-light)',
    borderColor: 'color-mix(in oklab, var(--color-astral-violet) 28%, transparent)',
  },
}

export function ClassesProof() {
  return (
    <div className="absolute inset-0 flex flex-col p-[18px]">
      <span className="inline-flex w-fit items-center rounded-pill border border-astral-violet/30 bg-astral-violet/[0.16] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-astral-violet-light">
        This week
      </span>
      <div className="mt-1 flex flex-col">
        {ROWS.map((r, i) => {
          const pill = PILL_STYLES[r.pillVariant]
          return (
            <div
              key={r.day}
              className="grid items-center gap-2.5 py-2.5"
              style={{
                gridTemplateColumns: '44px 1fr auto',
                borderBottom: i === ROWS.length - 1 ? 'none' : '1px dashed var(--hairline)',
              }}
            >
              <div
                className="text-center font-display text-[11px] leading-tight text-text-muted"
              >
                {r.month}
                <strong className="block text-[16px] font-normal text-text-primary">{r.day}</strong>
              </div>
              <div className="font-display text-text-primary" style={{ fontSize: '0.85rem', lineHeight: 1.2 }}>
                {r.title}
                <span className="mt-0.5 block font-body text-[10px] uppercase tracking-[0.16em] text-text-muted">
                  {r.meta}
                </span>
              </div>
              <span
                className="rounded-pill border px-2.5 py-1 text-[9px] font-medium uppercase tracking-[0.16em]"
                style={pill}
              >
                {r.pillText}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
